import request from './request'

export const getCaptcha = () => {
  return request({
    url: `/api/v1/captcha`,
    options: {
      responseType: 'blob',
    },
  })
}
